import React, { useState, useEffect } from 'react';
import InputLocation from '../atoms/InputLocation';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Maps from "../atoms/Maps";

const animatedComponents = makeAnimated();

const AddressForm = ( props ) => {
  useEffect(() => {
      if(!props.data.addressName && !props.data.addressPIC) {
          setEdit({...edit,name:false, info:false, location: false, pic: false})
      }
  }, []);

  const [ edit, setEdit ] = useState({
      name: true,
      info: true,
      location: true,
      pic: true
  });

  const setLocation = (address, coordinate, placeId) => {
    props.onSelectLocation(address,coordinate, placeId);
    setCoordinate({
      ...coordinate,
      latitude: coordinate.latitude,
      longitude: coordinate.longitude,
      exist: true
    });
  };

  const onClickEditLocation = () => {
      props.onEditLocation();
      setEdit({...edit, location:false})
  };

  const onLocationChange = (address) => {
      props.handleChangeLocation(address)
  };

  const onStoreChange = arr => {
    props.handleChangeStore(arr)
  };

  const [ coordinate, setCoordinate ] = useState({
    exist:false,
    latitude: -6.180511,
    longitude: 106.828383
  });

  return (
    <form>
      <div className="mb-2">Informasi Nama orang di titik penjemputan</div>
      {
          edit.name ?
          <div className="d-flex justify-content-between form-group ">
              <b>
                  {props.data.addressName}
              </b>
              <a onClick={() => setEdit({...edit, name:false})}>
                  <i className="fas fa-edit"></i>
              </a>
          </div>
          :
          <div className="form-row">
              <div className="form-group input-group-sm col-md-12">
                  <input
                      type="text"
                      onChange={props.handleChange('addressName')}
                      placeholder="Nama orang yang dapat dikontak di lokasi"
                      className="form-control"
                      value={props.data.addressName}
                      required
                  />
                  <small className="address-info">
                      Hindari penamaan ambigu seperti "Rumah Saya", "Toko Saya", dan sejenisnya.
                  </small>
              </div>
          </div>
      }
      <div className="mb-2">Kontak PIC di Lokasi</div>
      {
          edit.pic ?
              <div className="d-flex justify-content-between form-group ">
                  <b>
                      {props.data.addressPIC}
                  </b>
                  <a onClick={() => setEdit({...edit, pic:false})}>
                      <i className="fas fa-edit"></i>
                  </a>
              </div>
              :
              <div className="form-row">
                  <div className="form-group input-group-sm col-md-12">
                      <input
                          type="number"
                          onChange={props.handleChange('addressPIC')}
                          placeholder="No Telpon yang bisa dihubungi di lokasi"
                          className="form-control"
                          value={props.data.addressPIC}
                          required
                      />
                      <small className="address-info">
                          Nomor telepon ini akan digunakan agar kurir dapat menghubungi seseorang di lokasi tersebut.
                      </small>
                  </div>
              </div>
      }

      <div className="mb-2">Tentukan alamat pada peta</div>
      <div className="form-row">
        <div className="form-group input-group-sm col-md-12">
            {
                edit.location ?
                    <div className="d-flex justify-content-between form-group input-group-sm">
                        <b>
                            {props.data.addressDetails}
                        </b>
                        <a onClick={() => onClickEditLocation()}>
                            <i className="fas fa-edit"></i>
                        </a>
                    </div>
                    :
                    <InputLocation
                        setLocation={setLocation}
                        loading={props.locationLoading}
                        onLocationChange={onLocationChange}
                        value={props.data.addressDetails}
                        loadingText={"Mohon ditunggu. Sedang mencocokkan alamat..."}
                        placeholder="Masukkan alamat disini"
                        className="wrap-text mb-0"
                    />
            }
        </div>
        <div className="form-group input-group-sm col-md-12">
          <Maps
              originCoordinate={coordinate}
          />
        </div>
        <div className="form-group input-group-sm col-md-12 row">
            <div className="col-6">
                Provinsi <b>{props.data.admLvl1Name}</b><br/>
                Kota <b>{props.data.admLvl2Name}</b><br/>
            </div>
            <div className="col-6">
                Kecamatan <b>{props.data.admLvl3Name}</b><br/>
                Kodepos <b>{props.data.postalCode}</b><br/>
            </div>
        </div>
      </div>
      <div className="mb-2">Informasi Tambahan Alamat</div>
        {
            edit.info ?
                <div className="d-flex justify-content-between form-group input-group-sm">
                    <b>
                        {props.data.addressNote}
                    </b>
                    <a onClick={() => setEdit({...edit, info:false})}>
                        <i className="fas fa-edit"></i>
                    </a>
                </div>
                :
                <div className="form-row">
                    <div className={`form-group input-group-sm ${props.button ? 'col-md-10' : 'col-md-12'}`}>
                        <input
                            type="text"
                            onChange={props.handleChange('addressNote')}
                            placeholder="Patokan atau deskripsi lokasi (opsional). Mempermudah kurir."
                            className="form-control "
                            value={props.data.addressNote}
                            required
                        />
                    </div>
                    {
                        props.button &&
                        <div className="form-group input-group-sm col-md-2">
                            <button onClick={props.onSubmit} className="btn btn-primary btn-block">
                                {props.onSubmitText}
                            </button>
                        </div>
                    }
                </div>

        }
        <div className="mb-2">Koneksi Alamat ke Toko Online</div>
        <Select
            onChange={onStoreChange}
            closeMenuOnSelect={false}
            components={animatedComponents}
            placeholder={"Pilih Toko Online..."}
            noOptionsMessage={() => <div>Tidak ada toko lainnya</div>}
            value={props.data.stores}
            isMulti
            options={storesSelection}
        />
    </form>
  );
};


export default AddressForm;

const storesSelection = [
    { value: 'woocommerce', label: 'WooCommerce' }
]
